import styled from '@emotion/styled'
import Link from 'next/link'
import { useState } from 'react'
import { BsArrowsFullscreen } from 'react-icons/bs'
import { useSelector } from 'react-redux'
import decode from 'unescape'

import { useUser } from '../hooks'

import BandcampLink from './BandcampLink'
import ListItemArtwork from './ListItemArtwork'
import ListItemContainer from './ListItemContainer'

const ReleaseLinkContainer = styled.div`
  position: absolute;
  right: ${({ theme }) => theme.space[1]};
  top: ${({ theme }) => theme.space[1]};

  a {
    color: ${({ theme }) => theme.colors.text};

    svg,
    div {
      height: 20px;
      width: 20px;
    }
  }
`

const StyledBandcampLink = styled(BandcampLink)`
  bottom: ${({ theme }) => theme.space[1]};
  position: absolute;
  right: ${({ theme }) => theme.space[1]};
`

const ListItem = ({ i, listItem, play }) => {
  const [user] = useUser()
  const {
    artist,
    externalId,
    id,
    image,
    label,
    list_id: listId,
    title,
    url,
  } = listItem
  const { playIndex, playing, playingListId } = useSelector(
    (state) => state.player
  )
  const [removed, setRemoved] = useState(false)
  const isCurrentlyPlaying =
    listId === playingListId && playIndex === i && playing

  const handleClick = () => {
    if (!isCurrentlyPlaying) {
      play()
    }
  }

  if (removed) {
    return null
  } else {
    return (
      <ListItemContainer onClick={handleClick} playing={isCurrentlyPlaying}>
        <div className="flex items-center">
          <ListItemArtwork
            className="mr4-ns"
            externalId={externalId}
            image={image}
            playing={isCurrentlyPlaying}
            setRemoved={setRemoved}
          />
          <div className="flex flex-column">
            <div className="mb1 f5 f4-ns pr5">
              {decode(artist)} - <br className="db dn-ns" />
              {decode(title)}
            </div>

            {label !== artist && (
              <span className="gray f7 f6-ns tracked-light">
                {decode(label)}
              </span>
            )}
          </div>
        </div>

        {user && user.admin && (
          <ReleaseLinkContainer className="hover-child">
            <Link href={`/release/${id}`}>
              <a href={`/release/${id}`}>
                <BsArrowsFullscreen />
              </a>
            </Link>
          </ReleaseLinkContainer>
        )}

        <StyledBandcampLink className="hover-child" listId={listId} url={url} />
      </ListItemContainer>
    )
  }
}

export default ListItem
